import { render, staticRenderFns } from "./FirmAccounting.vue?vue&type=template&id=3b3cc0b4"
import script from "./FirmAccounting.vue?vue&type=script&lang=js"
export * from "./FirmAccounting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports